module.exports = __webpack_public_path__ + "static/img/logo12.dab0eb72.png";